import React from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
export function BonusesSection() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-31">
      <div className="max-w-[680px] mx-auto" data-id="element-32">
        {/* Transition */}
        <div className="text-center mb-16" data-id="element-33">
          <GiftIcon className="w-12 h-12 text-pink-dark mx-auto mb-6" data-id="element-34" />
          <p className="font-body text-lg md:text-xl text-dark-gray leading-relaxed" data-id="element-35">
            Cuando comprás la guía{' '}
            <strong className="font-bold" data-id="element-36">
              "Bikinis al Crochet: Tu Primera Pieza en 24 Horas"
            </strong>{' '}
            hoy, recibís GRATIS estos 5 bonos con valor total de{' '}
            <strong className="font-bold text-pink-dark line-through" data-id="element-37">
              $47 USD
            </strong>
          </p>
        </div>

        <div className="space-y-16" data-id="element-38">
          {/* BONO 1 */}
          <div className="bg-beige rounded-3xl overflow-hidden shadow-lg border border-pink-soft" data-id="element-39">
            <img src="https://cdn.magicpatterns.com/uploads/7VpiqQYWCabyzHbd2J9Ukq/bono1.png" alt="Kit Compra Cero Estrés" className="w-full h-auto object-cover" data-id="element-40" />
            <div className="p-6 md:p-8" data-id="element-41">
              <div className="inline-flex items-center gap-2 bg-pink-dark text-white px-4 py-1.5 rounded-full font-body font-bold text-sm mb-4" data-id="element-42">
                <GiftIcon className="w-4 h-4" data-id="element-43" /> BONO #1
              </div>
              <h3 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray mb-2" data-id="element-44">
                Kit "Compra Cero Estrés"
              </h3>
              <p className="font-body text-pink-dark font-semibold text-lg mb-4" data-id="element-45">
                Materiales Exactos + Alternativas (USA)
              </p>
              <p className="font-body text-medium-gray text-sm mb-6 uppercase tracking-wider font-semibold" data-id="element-46">
                Valor real: <span className="line-through" data-id="element-47">$9.40</span> →{' '}
                <span className="text-pink-dark" data-id="element-48">GRATIS</span>
              </p>

              <div className="font-body text-dark-gray space-y-4 mb-6" data-id="element-49">
                <p data-id="element-50">Antes de tejer, hay que comprar.</p>
                <p data-id="element-51">
                  Y si comprás el hilo equivocado, el hook incorrecto o lo que
                  "te pareció que era"… Te frustras antes de empezar.
                </p>
                <p data-id="element-52">
                  Este kit te dice exactamente qué buscar en Walmart, Michaels o
                  Amazon:
                </p>
              </div>

              <ul className="space-y-3 font-body text-dark-gray mb-6" data-id="element-53">
                <li className="flex items-start gap-3" data-id="element-54">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-55" />
                  <span data-id="element-56">
                    <strong className="font-bold" data-id="element-57">
                      Lista de compra mínima
                    </strong>{' '}
                    (sin gastar de más)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-58">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-59" />
                  <span data-id="element-60">
                    <strong className="font-bold" data-id="element-61">Regla 3C</strong> para elegir
                    yarn aunque no sepas nada de hilos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-62">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-63" />
                  <span data-id="element-64">
                    <strong className="font-bold" data-id="element-65">
                      Tabla de sustituciones
                    </strong>{' '}
                    "si no encuentro X, compro Y"
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-66">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-67" />
                  <span data-id="element-68">
                    <strong className="font-bold" data-id="element-69">Checklist imprimible</strong>{' '}
                    para ir a la tienda y listo
                  </span>
                </li>
              </ul>

              <div className="bg-white rounded-xl p-4 border border-gray-100" data-id="element-70">
                <p className="font-body text-dark-gray" data-id="element-71">
                  <strong className="font-bold text-pink-dark" data-id="element-72">
                    Resultado:
                  </strong>{' '}
                  comprás bien en 10 minutos y empezás hoy.
                </p>
              </div>
            </div>
          </div>

          {/* BONO 2 */}
          <div className="bg-beige rounded-3xl overflow-hidden shadow-lg border border-pink-soft" data-id="element-73">
            <img src="https://cdn.magicpatterns.com/uploads/3aVzLYkNNLTEaHSDnv7wSJ/bono2.png" alt="Guía Talle Real" className="w-full h-auto object-cover" data-id="element-74" />
            <div className="p-6 md:p-8" data-id="element-75">
              <div className="inline-flex items-center gap-2 bg-pink-dark text-white px-4 py-1.5 rounded-full font-body font-bold text-sm mb-4" data-id="element-76">
                <GiftIcon className="w-4 h-4" data-id="element-77" /> BONO #2
              </div>
              <h3 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray mb-2" data-id="element-78">
                Guía "Talle Real"
              </h3>
              <p className="font-body text-pink-dark font-semibold text-lg mb-4" data-id="element-79">
                Medidas + Ajuste Sin Complicarte (USA)
              </p>
              <p className="font-body text-medium-gray text-sm mb-6 uppercase tracking-wider font-semibold" data-id="element-80">
                Valor real: <span className="line-through" data-id="element-81">$9.40</span> →{' '}
                <span className="text-pink-dark" data-id="element-82">GRATIS</span>
              </p>

              <div className="font-body text-dark-gray space-y-4 mb-6" data-id="element-83">
                <p data-id="element-84">
                  El miedo más grande de cualquier principiante:{' '}
                  <em className="italic" data-id="element-85">"¿Y si no me queda?"</em>
                </p>
                <p data-id="element-86">Esta guía resuelve eso para siempre. Te enseña a:</p>
              </div>

              <ul className="space-y-3 font-body text-dark-gray mb-6" data-id="element-87">
                <li className="flex items-start gap-3" data-id="element-88">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-89" />
                  <span data-id="element-90">
                    Tomar las{' '}
                    <strong className="font-bold" data-id="element-91">2–4 medidas mínimas</strong>{' '}
                    que realmente importan
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-92">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-93" />
                  <span data-id="element-94">
                    Completar tu{' '}
                    <strong className="font-bold" data-id="element-95">worksheet de tallas</strong>{' '}
                    (sin tecnicismos)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-96">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-97" />
                  <span data-id="element-98">
                    Usar el{' '}
                    <strong className="font-bold" data-id="element-99">mapa de ajuste</strong> para
                    corregir "queda grande/chico" sin empezar de cero
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-100">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-101" />
                  <span data-id="element-102">
                    Hacer la{' '}
                    <strong className="font-bold" data-id="element-103">prueba al 70–90%</strong>{' '}
                    (antes de que sea tarde para ajustar)
                  </span>
                </li>
              </ul>

              <div className="bg-white rounded-xl p-4 border border-gray-100" data-id="element-104">
                <p className="font-body text-dark-gray" data-id="element-105">
                  <strong className="font-bold text-pink-dark" data-id="element-106">
                    Resultado:
                  </strong>{' '}
                  tu bikini te queda cómodo, seguro y favorecedor desde el
                  primer intento.
                </p>
              </div>
            </div>
          </div>

          {/* BONO 3 */}
          <div className="bg-beige rounded-3xl overflow-hidden shadow-lg border border-pink-soft" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/wEZimLXMs1uRQ4tezZsvzw/bono3.png" alt="Checklist 24 Horas Sin Trabarte" className="w-full h-auto object-cover" data-id="element-108" />
            <div className="p-6 md:p-8" data-id="element-109">
              <div className="inline-flex items-center gap-2 bg-pink-dark text-white px-4 py-1.5 rounded-full font-body font-bold text-sm mb-4" data-id="element-110">
                <GiftIcon className="w-4 h-4" data-id="element-111" /> BONO #3
              </div>
              <h3 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray mb-2" data-id="element-112">
                Checklist "24 Horas Sin Trabarte"
              </h3>
              <p className="font-body text-pink-dark font-semibold text-lg mb-4" data-id="element-113">
                Ruta de Producción Express
              </p>
              <p className="font-body text-medium-gray text-sm mb-6 uppercase tracking-wider font-semibold" data-id="element-114">
                Valor real: <span className="line-through" data-id="element-115">$9.40</span> →{' '}
                <span className="text-pink-dark" data-id="element-116">GRATIS</span>
              </p>

              <div className="font-body text-dark-gray space-y-4 mb-6" data-id="element-117">
                <p data-id="element-118">Saber tejer no es el problema.</p>
                <p data-id="element-119">
                  El problema es{' '}
                  <strong className="font-bold" data-id="element-120">
                    no saber qué hacer en cada momento
                  </strong>
                  .
                </p>
                <p data-id="element-121">
                  Este checklist te da una ruta de 8 bloques para avanzar sin
                  improvisar:
                </p>
              </div>

              <ul className="space-y-3 font-body text-dark-gray mb-6" data-id="element-122">
                <li className="flex items-start gap-3" data-id="element-123">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-124" />
                  <span data-id="element-125">
                    <strong className="font-bold" data-id="element-126">Bloque por bloque</strong>{' '}
                    (sin saltar pasos)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-127">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-128" />
                  <span data-id="element-129">
                    <strong className="font-bold" data-id="element-130">Tracker 24h</strong> para
                    mantener el ritmo
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-131">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-132" />
                  <div data-id="element-133">
                    <span className="font-bold" data-id="element-134">Protocolo Anti‑Traba</span> para
                    3 escenarios comunes:
                    <ul className="mt-2 ml-2 space-y-1 text-sm text-medium-gray" data-id="element-135">
                      <li data-id="element-136">- "No entiendo este paso"</li>
                      <li data-id="element-137">- "Me quedó disparejo"</li>
                      <li data-id="element-138">- "Me frustré y quiero dejarlo"</li>
                    </ul>
                  </div>
                </li>
              </ul>

              <div className="bg-white rounded-xl p-4 border border-gray-100" data-id="element-139">
                <p className="font-body text-dark-gray" data-id="element-140">
                  <strong className="font-bold text-pink-dark" data-id="element-141">
                    Resultado:
                  </strong>{' '}
                  completás tu primera pieza sin abandonarla a la mitad.
                </p>
              </div>
            </div>
          </div>

          {/* BONO 4 */}
          <div className="bg-beige rounded-3xl overflow-hidden shadow-lg border border-pink-soft" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/jxWkm23PVCNujS6Cavt1Kf/bono4.png" alt="Pack Textos que Venden" className="w-full h-auto object-cover" data-id="element-143" />
            <div className="p-6 md:p-8" data-id="element-144">
              <div className="inline-flex items-center gap-2 bg-pink-dark text-white px-4 py-1.5 rounded-full font-body font-bold text-sm mb-4" data-id="element-145">
                <GiftIcon className="w-4 h-4" data-id="element-146" /> BONO #4
              </div>
              <h3 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray mb-2" data-id="element-147">
                Pack "Textos que Venden"
              </h3>
              <p className="font-body text-pink-dark font-semibold text-lg mb-4" data-id="element-148">
                Descripción + Bullets para tu Página
              </p>
              <p className="font-body text-medium-gray text-sm mb-6 uppercase tracking-wider font-semibold" data-id="element-149">
                Valor real: <span className="line-through" data-id="element-150">$9.40</span> →{' '}
                <span className="text-pink-dark" data-id="element-151">GRATIS</span>
              </p>

              <div className="font-body text-dark-gray space-y-4 mb-6" data-id="element-152">
                <p data-id="element-153">Este bono es especial. Porque no solo aprendés a tejer.</p>
                <p data-id="element-154">
                  Si querés{' '}
                  <strong className="font-bold" data-id="element-155">vender tus piezas</strong> o{' '}
                  <strong className="font-bold" data-id="element-156">armar tu propia tienda</strong>{' '}
                  en el futuro…
                </p>
                <p data-id="element-157">
                  Este pack te da los textos listos para presentar tu producto
                  de forma profesional:
                </p>
              </div>

              <ul className="space-y-3 font-body text-dark-gray mb-6" data-id="element-158">
                <li className="flex items-start gap-3" data-id="element-159">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-160" />
                  <span data-id="element-161">
                    <strong className="font-bold" data-id="element-162">10 headlines</strong> probados
                    para captar atención
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-163">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-164" />
                  <span data-id="element-165">
                    <strong className="font-bold" data-id="element-166">
                      Bullets por tipo de objeción
                    </strong>{' '}
                    (miedo, tiempo, principiante)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-167">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-168" />
                  <span data-id="element-169">
                    <strong className="font-bold" data-id="element-170">Descripciones cortas</strong>{' '}
                    para Shopify, landing y checkout
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-171">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-172" />
                  <span data-id="element-173">
                    <strong className="font-bold" data-id="element-174">CTAs listos</strong> para
                    botones y anuncios
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-175">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-176" />
                  <span data-id="element-177">
                    <strong className="font-bold" data-id="element-178">
                      Scripts para Reels, TikTok y DMs
                    </strong>
                  </span>
                </li>
              </ul>

              <div className="bg-white rounded-xl p-4 border border-gray-100" data-id="element-179">
                <p className="font-body text-dark-gray" data-id="element-180">
                  <strong className="font-bold text-pink-dark" data-id="element-181">
                    Resultado:
                  </strong>{' '}
                  tu producto se ve más profesional en minutos (sin saber de
                  copywriting).
                </p>
              </div>
            </div>
          </div>

          {/* BONO 5 */}
          <div className="bg-beige rounded-3xl overflow-hidden shadow-lg border border-pink-soft" data-id="element-182">
            <img src="https://cdn.magicpatterns.com/uploads/fpDyME8S91nuWoYaBSns2x/bono5.png" alt="Mini Guía Acabado Pro" className="w-full h-auto object-cover" data-id="element-183" />
            <div className="p-6 md:p-8" data-id="element-184">
              <div className="inline-flex items-center gap-2 bg-pink-dark text-white px-4 py-1.5 rounded-full font-body font-bold text-sm mb-4" data-id="element-185">
                <GiftIcon className="w-4 h-4" data-id="element-186" /> BONO #5
              </div>
              <h3 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray mb-2" data-id="element-187">
                Mini Guía "Acabado Pro"
              </h3>
              <p className="font-body text-pink-dark font-semibold text-lg mb-4" data-id="element-188">
                Remates Limpios + Errores Típicos
              </p>
              <p className="font-body text-medium-gray text-sm mb-6 uppercase tracking-wider font-semibold" data-id="element-189">
                Valor real: <span className="line-through" data-id="element-190">$9.40</span> →{' '}
                <span className="text-pink-dark" data-id="element-191">GRATIS</span>
              </p>

              <div className="font-body text-dark-gray space-y-4 mb-6" data-id="element-192">
                <p data-id="element-193">
                  La diferencia entre una pieza "de práctica" y una pieza que
                  parece de tienda… Son los últimos 7 minutos.
                </p>
                <p data-id="element-194">Esta mini guía te enseña:</p>
              </div>

              <ul className="space-y-3 font-body text-dark-gray mb-6" data-id="element-195">
                <li className="flex items-start gap-3" data-id="element-196">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-197" />
                  <span data-id="element-198">
                    <strong className="font-bold" data-id="element-199">5 acabados simples</strong>{' '}
                    que elevan el resultado al instante
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-200">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-201" />
                  <div data-id="element-202">
                    <span className="font-bold" data-id="element-203">Soluciones rápidas</span> a los
                    5 errores típicos de principiante:
                    <ul className="mt-2 ml-2 space-y-1 text-sm text-medium-gray" data-id="element-204">
                      <li data-id="element-205">- Tejido disparejo</li>
                      <li data-id="element-206">- Punto abierto/transparente</li>
                      <li data-id="element-207">- Hebras visibles</li>
                      <li data-id="element-208">- Uniones flojas</li>
                      <li data-id="element-209">- Tiras que se aflojan</li>
                    </ul>
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-210">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-211" />
                  <span data-id="element-212">
                    <strong className="font-bold" data-id="element-213">
                      Rutina final de 7 minutos
                    </strong>{' '}
                    para cerrar la pieza como pro
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-214">
                  <CheckIcon className="w-5 h-5 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-215" />
                  <span data-id="element-216">
                    <strong className="font-bold" data-id="element-217">Checklist imprimible</strong>{' '}
                    de terminación
                  </span>
                </li>
              </ul>

              <div className="bg-white rounded-xl p-4 border border-gray-100" data-id="element-218">
                <p className="font-body text-dark-gray" data-id="element-219">
                  <strong className="font-bold text-pink-dark" data-id="element-220">
                    Resultado:
                  </strong>{' '}
                  tu primera pieza se ve prolija, usable y "comprada".
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}